import { useSignupMutation } from 'util/rtk-api'
import { useDocTitle } from 'util/hooks'

import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { showMutationError } from 'util/mutation-error'
import { AuthCard, AuthDivider } from 'auth/auth-card'

export const Signup = () => {
	const navigate = useNavigate()
	const [ signup ] = useSignupMutation()

	const [ firstName, setFirstName ] = useState()
	const [ lastName, setLastName ] = useState()
	const [ email, setEmail ] = useState()
	const [ password, setPassword ] = useState()

	const onPasswordBlur = ({ target }) => {
		const conditions = [
			/.{8,}/,
			/[0-9]+/,
			/[a-z]+/,
			/[A-Z]+/,
			/[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=]+/,
		]

		setPassword(target.value)

		if (
			conditions.every(pattern => target.value.match(pattern))
		) {
			target.setCustomValidity('')
			return
		}
		
		target.setCustomValidity(
			'The password must be at least 8 characters long and must use a lower case character, an upper case character, a number, and a special character.'
		)
	}

	// Checked as it is typed, not only on blur: Enter straight after typing the confirmation could
	// otherwise submit a mismatch.
	const onConfirmPasswordChange = ({ target }) => {
		if (
			target.value === password
		) {
			target.setCustomValidity('')
			return
		}

		target.setCustomValidity(
			'This does not match the password entered above'
		)
	}

	const onFormSubmit = async e => {
		e.preventDefault()

		const result = await signup({ firstName, lastName, email, password })

		if (showMutationError(result)) return

		// EH-17: the server answers identically whether or not the email already
		// has an account (no enumeration), so there is no 'already exists' branch
		// here. The verification page states the neutral case and offers Log in.
		navigate(`/verification?email=${email}`)
	}

	useDocTitle('All for One - Sign up')

	return (
		<AuthCard eyebrow="Create account" title="Get started" subtitle="Create your account to start designing lessons for every mind.">
			<form
				id="signup-form"
				className="auth-form--long"
				action="#"
				method="POST"
				onSubmit={onFormSubmit}
			>
				<div className="auth-field">
					<label htmlFor="first-name" className="auth-field-label">First name</label>
					<input 
						type="text" 
						id="first-name" 
						name="first-name" 
						placeholder="First Name" 
						required
						onChange={({ target }) => setFirstName(target.value)}
					/>
				</div>

				<div className="auth-field">
					<label htmlFor="last-name" className="auth-field-label">Last name</label>
					<input 
						type="text" 
						id="last-name" 
						name="last-name" 
						placeholder="Last Name" 
						required
						onChange={({ target }) => setLastName(target.value)}
					/>
				</div>

				<div className="auth-field">
					<label htmlFor="email" className="auth-field-label">Email</label>
					<input 
						type="email" 
						id="email" 
						name="email" 
						placeholder="Email" 
						required
						onChange={({ target }) => setEmail(target.value)}
					/>
				</div>

				<div className="auth-field">
					<label htmlFor="password" className="auth-field-label">Password</label>
					<input 
						type="password" 
						id="password" 
						name="password" 
						placeholder="Password" 
						required
						onChange={({ target }) => setPassword(target.value)}
						onBlur={onPasswordBlur}
					/>
				</div>

				<div className="auth-field">
					<label htmlFor="confirm-password" className="auth-field-label">Confirm password</label>
					<input 
						type="password" 
						id="confirm-password" 
						name="confirm-password" 
						placeholder="Confirm Password" 
						required
						onChange={onConfirmPasswordChange}
					/>
				</div>

				{/* not wrapped in a field: the design has the button as a direct child of the form */}
				<button type="submit" className="auth-btn">Create account</button>
			</form>

			<AuthDivider />

			<p className="auth-prompt">
				Already have an account? <Link to="/login" className="auth-link">Log in</Link>
			</p>
		</AuthCard>
	)
}
